import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { NavbarComponent } from '../../../../components/navbar/navbar.component';
import { TabAccountComponent } from '../../../../components/tab-account/tab-account.component';
import { GridDataComponent } from '../../../../components/grid-data/grid-data.component';
import { FooterComponent } from '../../../../components/footer/footer.component';
import { SwitcherComponent } from '../../../../components/switcher/switcher.component';

import Package from '../../../../data/packages.json'
import {TabManagementComponent} from '../../../../components/tab-management/tab-management.component';

@Component({
  selector: 'app-management',
  standalone: true,
  imports: [
    CommonModule,
    NavbarComponent,
    GridDataComponent,
    FooterComponent,
    SwitcherComponent,
    TabManagementComponent
  ],
  templateUrl: './management.component.html',
  styleUrl: './management.component.scss'
})
export class ManagementComponent {
  package = Package
}
